export default "__VITE_ASSET__BKTHKIPf__"